import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { AddPeriodDialogComponent } from 'src/app/core/dialogs/add-period-dialog/add-period-dialog.component';
import { AddQueueDialogComponent } from 'src/app/core/dialogs/add-queue-dialog/add-queue-dialog.component';
import { DeleteDialogComponent } from 'src/app/core/dialogs/delete-dialog/delete-dialog.component';
import { BtnCellRendererEditDelete } from 'src/app/core/grid/btn-cell-render-edit-delete';
import { ExcelService } from 'src/app/service/excel.service';
import { GroupIStateService } from 'src/app/service/groupi-state.service';
import { PeriodsManageService } from 'src/app/service/management/periods-manage.service';
import { PeriodsService } from 'src/app/service/periods.service';
@Component({
  selector: 'app-periods',
  templateUrl: './periods.component.html',
  styleUrls: ['./periods.component.scss'],
  standalone: false
})
export class PeriodsComponent implements OnInit {
  gridApi: any;
  icons;
  columnDefs = [];
  displayRowData :any = [];
  context: any;
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;

  periodData = []
  defaultColDef;
  successMessage
  errorMessage
  isAccessible = true;
  constructor(private readonly router: Router, public dialog: MatDialog, private readonly periodsService: PeriodsService, private readonly constants: Constants,
    private readonly excelService: ExcelService, private readonly periodsManageService: PeriodsManageService, private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly groupIStateService: GroupIStateService) {
    this.context = {
      componentParent: this
    };

    this.defaultColDef = {
      suppressMovable: true, wrapText: true, floatingFilter: true,
      filterParams: {
        newRowsAction: 'keep'
      },
      suppressHeaderFilterButton: true, suppressCellSelection: true
    }
  }

  ngOnInit(): void {
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    this.columnDefs = [
      {
        headerName: "ID", field: "periodId", autoHeight: true, width: 60
      },
      {
        headerName: "Period", field: "period", sortable: true, unSortIcon: true, floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', width: 95
      },
      {
        headerName: "Midwest Crossdock Start", field: "crossDockStart", autoHeight: true, width: 100
      }, {
        headerName: "Midwest Crossdock End", field: "crossDockEnd", autoHeight: true, width: 95
      },
      {
        headerName: "PSC Start", field: "midWestStart", autoHeight: true, width: 85
      }, {
        headerName: "PSC End", field: "midWestEnd", autoHeight: true, width: 85
      }, {
        headerName: "NAMC Start", field: "westCoastStart", autoHeight: true, width: 95
      }, {
        headerName: "NAMC End", field: "westCoastEnd", autoHeight: true, width: 95
      },
      {
        headerName: "Action", field: "periods_editdelete",
        cellRenderer: BtnCellRendererEditDelete, width: 60
      }];
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    this.getPeriodList();
    // this.checkRoles();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }
  async checkRoles() {
    await this.groupIStateService.getRoles();
    const roles = this.groupIStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin)) {
    //   this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // }
  }

  getPeriodList() {
    const tempPeriod = JSON.parse(localStorage.getItem("period_data"))
    if (tempPeriod && tempPeriod.length > 0) {
      this.periodData = tempPeriod
      this.refreshData();
    } else {
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      this.periodsService.getPeriodsList().subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (response.length > 0) {
            this.periodData = response
            this.refreshData();
          }
        }, _error => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.errorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      );
    }
  }
  refreshData() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    this.periodsManageService.loadDataPeriods().subscribe(
      response => {
        this.displayRowData = response
        if (this.displayRowData.length > 0) {
          const sortAlphaNum = (a, b) => a.period.localeCompare(b.period, 'en', { numeric: true })
          this.displayRowData = this.displayRowData.toSorted(sortAlphaNum).reverse();
        }
        this.syncGridWithArrayData();
      }, _error => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.errorMessage = this.constants.APIErrorMessage;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTime);
      }
    );

  }
  syncGridWithArrayData() {
    const model = this.gridApi?.getFilterModel();
    this.gridApi?.setGridOption('rowData', this.displayRowData)
    this.rowCount = this.displayRowData.length;
    this.gridApi?.setFilterModel(model);
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
  }

  sizeToFit() { this.gridApi?.sizeColumnsToFit(); }
  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }
  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") { // NOSONAR
      this.gridApi?.setGridOption('paginationPageSize', Number(this.displayRowData.length));
    }
    else {
      this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));

    }
  }
  goToNexpage() { this.gridApi.paginationGoToNextPage(); }

  goToPreviousPage() { this.gridApi.paginationGoToPreviousPage() }

  goToFirstPage() { this.gridApi.paginationGoToFirstPage(); }

  goToLastPage() { this.gridApi.paginationGoToLastPage() }

  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) { // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) { // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }
  AddPeriod() {
    const dialogRef = this.dialog.open(
      AddPeriodDialogComponent, {
      disableClose: true,
      width: '550px',
      height: '310px',
      data: {
        header: 'Add Period',
        eventType: 'ADD',
        periodData: this.periodData,
        oldPeriods: this.displayRowData.map(x => x.period)
      }
    });


    dialogRef.afterClosed().subscribe(result => {
      const displayRowIndex = -1;
      if (result.event == 'SaveEvent') {
        //ADD API CALL FROM DIALOG
        if (result.eventResponse == "Success") { // NOSONAR
          this.successMessage = this.constants.APIDataSaved;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
        this.refreshData();

      }
    });
  }

  editTemplateRow(data, _pageName): void {
    console.info(data, "data")
    const dialogRef = this.dialog.open(
      AddPeriodDialogComponent, {
      disableClose: true,
      width: '550px',
      height: '310px',
      data: {
        header: 'Edit Period',
        eventType: 'EDIT',
        periodData: this.periodData,
        data: data,
        periodId: data.periodId,
        oldPeriods: this.displayRowData.map(x => x.period)
      }
    });


    dialogRef.afterClosed().subscribe(result => {
      if (result.event == 'SaveEvent') { // NOSONAR
        if (result.eventResponse == "Success") { // NOSONAR
          this.successMessage = this.constants.APIDataSaved;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
        this.refreshData();
      }
    });
  }
  deleteTemplateRow(data, _pagename) {

    let displayRowIndex;


    const dialogRef = this.dialog.open(
      DeleteDialogComponent, {
      disableClose: true,
      width: '500px',
      height: '170px',
      data: {
        header: 'Are you sure you want to delete this Period?',
        description: data.period,
      }
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'ConfirmEvent') { // NOSONAR
        this.ngxUiLoaderService.start(this.constants.LoaderComponent)
        this.periodsManageService.deletePeriod(data.periodId).subscribe(
          response => {

            if (response == "Success") { // NOSONAR
              this.successMessage = this.constants.APIDataDeleted;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTime);
              displayRowIndex = this.displayRowData.findIndex(x => x.periodId == data.periodId)
              this.displayRowData.splice(displayRowIndex, 1); 
              this.gridApi?.setGridOption('rowData', this.displayRowData)
              this.rowCount = this.displayRowData.length;
            } // NOSONAR
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)

          }, _error => {

            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            this.errorMessage = this.constants.APIErrorMessage;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTime);
          }
        );
      }
    });
  }
  AddToQueue(): void {

    const dialogRef = this.dialog.open(AddQueueDialogComponent, {
      disableClose: true,
      width: '500px',
      height: '240px',
      data: { header: 'Add To Queue' }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
      if (result.event == 'SaveEvent') { // NOSONAR
        if (result.data == "Success") { // NOSONAR
          this.successMessage = this.constants.APIAddToQueueSuccess;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      }
    });
  }
  exportPeriods() {
    if (this.displayRowData) {
      if (this.displayRowData.length > 0) {
        const exportData = [];
        this.displayRowData.forEach(e => {
          const obj = {
            period: e.period,
            crossDockStart: e.crossDockStart,
            crossDockEnd: e.crossDockEnd,
            midWestStart: e.midWestStart,
            midWestEnd: e.midWestEnd,
            westCoastStart: e.westCoastStart,
            westCoastEnd: e.westCoastEnd
          };
          exportData.push(obj);
        });

        const headers = ['Period', 'Midwest Crossdock Start', 'Midwest Crossdock  End', 'PSC Start', 'PSC  End', 'NAMC Start', 'NAMC End'];
        this.excelService.exportAsExcelFile(exportData, 'PERIODS', headers);
      }
    }
  }

  openRouteLevel(route) {
    this.router.navigate([`${route}`]);
  }
}
